import React, { useMemo, useState, useEffect } from 'react';
import styles from './MainNavigation.module.scss';
import { addCustomPathToLink, generateKey } from '../../functions';
import { Link } from 'react-router-dom';

const HamburgerMenuItem = ({ type, item, parentKey = null }) => {
  const slug = !!item?.slug && item.slug.length > 1 ? `${!!item?.slugPrefix ? item.slugPrefix + '/' : ''}${item.slug}` : '#';
  // console.log({ item });
  const ListParentItem = ({ item }) => {
    const [isActive, setIsActive] = useState(false);

    const handleClick = (e) => {
      setIsActive((prevState) => !prevState);
      let current = e.currentTarget;
      let nextSibling = current.nextElementSibling;
      while (nextSibling && nextSibling.hasAttribute('data-key') && nextSibling.getAttribute('data-key') === parentKey) {
        nextSibling.classList.toggle(styles.menuChildItemActive);
        nextSibling = nextSibling.nextElementSibling;
      }
      document.getElementById('menuSwiper').swiper.slideTo(item.rootid);
    };

    //     const handleClick = (e) => {
    //   let current = e.currentTarget;

    //   setIsActive((prevState) => !prevState);
    //   let nextSibling = current.nextElementSibling;
    //   let mainItems = document.querySelectorAll(`.${styles.mainItem}`);
    //   for (let mainItem of mainItems) {
    //     if (mainItem !== current) {
    //       mainItem.classList.remove(styles.mainItemActive);
    //     }
    //   }
    //   let siblings = document.querySelectorAll(`.${styles.childrenItem}`);
    //   for (let sibling of siblings) {
    //     if (sibling !== nextSibling) {
    //       sibling.classList.remove(styles.menuChildItemActive);
    //     }
    //   }
    //   if (current.classList.contains(styles.mainItemActive)) {
    //     current.classList.remove(styles.mainItemActive);
    //     while (nextSibling && nextSibling.hasAttribute('data-key') && nextSibling.getAttribute('data-key') === parentKey) {
    //       nextSibling.classList.remove(styles.menuChildItemActive);
    //       nextSibling = nextSibling.nextElementSibling;
    //     }
    //   } else {
    //     current.classList.add(styles.mainItemActive);
    //     document.getElementById('menuSwiper').swiper.slideTo(item.rootid);
    //     while (nextSibling && nextSibling.hasAttribute('data-key') && nextSibling.getAttribute('data-key') === parentKey) {
    //       nextSibling.classList.add(styles.menuChildItemActive);
    //       nextSibling = nextSibling.nextElementSibling;
    //     }
    //   }
    // };

    return (
      <li
        data-key={parentKey}
        data-id={item.rootid}
        className={`${isActive ? styles.mainItemActive : ''} ${styles.mainItem} 
      ${
        item.themeColor === 'theme-kitchen'
          ? styles['theme-kitchen']
          : item.themeColor === 'theme-default'
          ? styles['theme-bathroom']
          : item.themeColor === 'theme-interiors'
          ? styles['theme-interiors']
          : item.themeColor === 'theme-trends'
          ? styles['theme-trends']
          : ''
      } ${item.url ? styles.withOutAccordion : ''}`}
        onClick={handleClick}
      >
        {item.url ? (
          <a className={styles.mainLink} href={addCustomPathToLink(item.url)} aria-label={item.name}>
            {item.name}
          </a>
        ) : (
          item.name
        )}
      </li>
    );
  };

  const MemoizedListParentItem = useMemo(() => <ListParentItem item={item} />, [item]);

  return !!item?.slug ? (
    <li
      data-key={parentKey}
      className={`${styles.childrenItem}  ${
        item.themeColor === 'theme-kitchen'
          ? styles['theme-kitchen']
          : item.themeColor === 'theme-default'
          ? styles['theme-bathroom']
          : item.themeColor === 'theme-interiors'
          ? styles['theme-interiors']
          : item.themeColor === 'theme-trends'
          ? styles['theme-trends']
          : ''
      }`}
      key={generateKey()}
    >
      <Link to={addCustomPathToLink(slug)} aria-label={item.name}>
        {item.name}
      </Link>
    </li>
  ) : (
    MemoizedListParentItem
  );
};

export default HamburgerMenuItem;
